import React from 'react';
import { Printer, ArrowLeft, FolderOpen } from 'lucide-react';

export default function FieldReportToolbar({ title, onPrint, onBack }) {
  return (
    <div
      className="no-print sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="max-w-4xl mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {onBack && (
            <button 
              onClick={onBack}
              data-testid="field-report-toolbar-back"
              className="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200 transition-all mr-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
          )}
          <span className="font-semibold text-slate-700 text-sm" data-testid="field-report-toolbar-title">{title}</span>
        </div>
        <div className="flex items-center gap-2">
          <button 
            onClick={onPrint} 
            data-testid="field-report-toolbar-print"
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-orange-600 text-white hover:bg-orange-700 transition-all shadow-sm"
          >
            <Printer className="w-4 h-4" />
            Print / Save PDF
          </button>
        </div>
      </div>
      <div
        className="max-w-4xl mx-auto px-6 pb-3 flex items-start gap-2 text-xs text-amber-800"
        data-testid="pdf-storage-notice-toolbar"
      >
        <FolderOpen className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-600" aria-hidden="true" />
        <p className="leading-snug">
          Save this PDF to OneDrive or your filing system. It will not be saved automatically.
        </p>
      </div>
    </div>
  );
}
